import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import * as actions from 'actions';

import moment from "moment";

import withStyles from "@material-ui/core/styles/withStyles";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";


import CustomInput from "components/CustomInput/CustomInput.jsx";

import {
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Row,
  Col,
  Button,
  Table,
  CardHeader,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

import Popover from '@material-ui/core/Popover';

import Form04Style from "assets/jss/material-dashboard-pro-react/views/form04Style.jsx";

import defaultAvatar from "assets/img/placeholder.jpg";
import { Checkbox, Icon } from '@material-ui/core';

import { FORM_TYPE } from "constants/form";

import { sumScores } from "components/Form/helper";

import _ from "lodash";
import {
  analysis간이정신상태검사,
  analysis수단적일상생활활동,
  analysis기본적일상생활활동,
  analysis여가활동,
  analysis사회활동,
  analysis정서,
  analysis건강상태,
  analysis생활습관,
  analysis신체활동,
  analysis영양,
  analysis행동,
  analysis환경,
  analysis지원체계,
  analysis돌봄환경,
  analysis활동수준,
  analysis생활사,
} from 'components/Form/helper';
import { getFormDataFromSku } from 'components/Form/helper';

export class Form04 extends Component {
  static propTypes = {
    // classes: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    console.log('form04 props = ', props);
    const gradedPerson = this.props.location?.state?.gradedPerson || this.props.gradedPerson || this.props.location?.state?.currentDoc?.target || this.props.currentDoc.target;
    const {
      uid,
      org_id,
      name,
      profile_image_url = "",
      gender,
      birthday: rawBirthday
    } = gradedPerson;

    console.log('gradedPerson = ', gradedPerson);
    const readOnly = Boolean(this.props.location?.state?.readOnly || this.props.readOnly);

    const birthday = rawBirthday?.constructor.name !== "String"
      ? moment(birthday?.toDate())
      : moment(rawBirthday);
    const currentDoc = this.props.location?.state?.currentDoc || this.props.currentDoc;

    console.log('currentDoc = ', currentDoc);

    this.state = {
      gradedPerson,
      readOnly,
      anchorEl: {},
      currentDoc,
      uid,
      valueState: currentDoc
        ? currentDoc.valueState
        : {},
      name,
      profile_image_url,
      gender,
      birthday,
      org_id: this.props.location?.state?.org_id || this.props.org_id,
      goals: [
        { title: "", progress: null },
        { title: "", progress: null },
        { title: "", progress: null },
      ]
    }
  }

  initData(docs) {
    if (!docs || docs.length === 0) {
      // do not waste time for empty data;
      return;
    }
    if (_.isEqual(this.state.docs, docs)) {
      // do not waste time for the same data
      return;
    }

    const form02_01_doc = _(docs).filter({ form: { sku: "form02_01" } }).sortBy("created_at").last();
    const form02_02_doc = _(docs).filter({ form: { sku: "form02_02" } }).sortBy("created_at").last();
    const form02_03_doc = _(docs).filter({ form: { sku: "form02_03" } }).sortBy("created_at").last();
    // const form02_05_doc = _(docs).filter({ form: { sku: "form02_05" } }).sortBy("created_at").last();
    const form02_06_doc = _(docs).filter({ form: { sku: "form02_06" } }).sortBy("created_at").last();
    const form02_07_doc = _(docs).filter({ form: { sku: "form02_07" } }).sortBy("created_at").last();
    const form02_08_doc = _(docs).filter({ form: { sku: "form02_08" } }).sortBy("created_at").last();
    const form02_09_doc = _(docs).filter({ form: { sku: "form02_09" } }).sortBy("created_at").last();
    const form02_10_doc = _(docs).filter({ form: { sku: "form02_10" } }).sortBy("created_at").last();
    const form02_11_doc = _(docs).filter({ form: { sku: "form02_11" } }).sortBy("created_at").last();
    const form02_12_doc = _(docs).filter({ form: { sku: "form02_12" } }).sortBy("created_at").last();
    const form02_13_doc = _(docs).filter({ form: { sku: "form02_13" } }).sortBy("created_at").last();
    const form02_14_doc = _(docs).filter({ form: { sku: "form02_14" } }).sortBy("created_at").last();
    const form02_15_doc = _(docs).filter({ form: { sku: "form02_15" } }).sortBy("created_at").last();
    const form02_16_doc = _(docs).filter({ form: { sku: "form02_16" } }).sortBy("created_at").last();
    const form02_19_doc = _(docs).filter({ form: { sku: "form02_19" } }).sortBy("created_at").last();
    const form02_20_1_doc = _(docs).filter({ form: { sku: "form02_20_1" } }).sortBy("created_at").last();
    const form02_20_2_doc = _(docs).filter({ form: { sku: "form02_20_2" } }).sortBy("created_at").last();
    const form02_20_3_doc = _(docs).filter({ form: { sku: "form02_20_3" } }).sortBy("created_at").last();

    const 생활사분석 = analysis생활사(form02_01_doc?.valueState);
    const 활동수준분석 = analysis활동수준(form02_02_doc?.valueState);
    const mmse_score = form02_03_doc ? sumScores(form02_03_doc.valueState["간이정신상태검사"]) : "N/A";
    const gds_score = form02_10_doc ? sumScores(form02_10_doc.valueState["정서"]) : "N/A";
    const 간이정신상태검사분석 = analysis간이정신상태검사(form02_03_doc?.valueState);
    const 수단적일상생활활동분석 = analysis수단적일상생활활동(form02_06_doc?.valueState);
    const 기본적일상생활활동분석 = analysis기본적일상생활활동(form02_07_doc?.valueState);
    const 여가활동분석 = analysis여가활동(form02_08_doc?.valueState);
    const 사회활동분석 = analysis사회활동(form02_09_doc?.valueState);
    const 정서분석 = analysis정서(form02_10_doc);
    const 건강상태분석 = analysis건강상태(form02_11_doc?.valueState);
    const 생활습관분석 = analysis생활습관(form02_12_doc?.valueState);
    const 신체활동분석 = analysis신체활동(form02_12_doc?.valueState);
    const 영양분석 = analysis영양(form02_12_doc?.valueState);
    const 행동분석 = analysis행동(form02_13_doc?.valueState);
    const 환경분석 = analysis환경(form02_14_doc?.valueState);
    const 지원체계분석 = analysis지원체계(form02_19_doc?.valueState);
    const 돌봄환경분석 = analysis돌봄환경({
      ...form02_20_1_doc?.valueState,
      ...form02_20_2_doc?.valueState,
      ...form02_20_3_doc?.valueState
    });


    // console.log('여가활동분석', 여가활동분석);
    // console.log('form02_01_doc', form02_01_doc);
    // console.log('form02_02_doc', form02_02_doc);


    this.setState({
      docs,
      valueState: {
        MMSE: mmse_score,
        CDR: '',
        GDS: gds_score,
        개별성_생활사_강점: 생활사분석?.strong,
        개별성_생활사_제한요구사항: 생활사분석?.weak,
        개별성_생활사_하루일과: 생활사분석?.하루일과,
        개별성_활동수준_강점: 활동수준분석?.strong === '' ? '계획수준의 활동이 없음' : `계획수준의 활동: ${활동수준분석?.strong || ''}`,
        개별성_활동수준_제한요구사항: 활동수준분석?.weak === '' ? '모두 계획수준을 유지함' : `탐색, 감각, 반사수준 활동들: ${활동수준분석?.weak || ''}`,
        개별성_활동수준_활동수준: 활동수준분석?.활동수준 || '',
        개별성_활동수준_읽기: 생활사분석?.읽기 || '',
        개별성_활동수준_쓰기: 생활사분석?.쓰기 || '',
        자립_인지_강점: `점수가 높은편인 영역: ${간이정신상태검사분석?.strong?.section || ''}`,
        자립_인지_제한요구사항: `특히 점수가 낮은 영역: ${간이정신상태검사분석?.weak?.section || ''}`,
        자립_수단적_강점: `가능한 일상생활 영역: ${수단적일상생활활동분석?.strong?.section || ''}`,
        자립_수단적_제한요구사항: `도움이 필요한 일상생활 영역: ${수단적일상생활활동분석?.weak?.section || ''}`,
        자립_기본적_강점: `가능한 일상생활 영역: ${기본적일상생활활동분석?.strong?.section || ''}`,
        자립_기본적_제한요구사항: `도움이 필요한 일상생활 영역: ${기본적일상생활활동분석?.weak?.section || ''}`,
        사회심리_여가활동_강점: 여가활동분석?.strong ? `하고 있거나 즐거운 활동: ${여가활동분석?.strong}` : null,
        사회심리_여가활동_강점_full: 여가활동분석?.strongFull ? `하고 있거나 즐거운 활동: ${여가활동분석?.strongFull}` : null,
        사회심리_여가활동_제한요구사항: 여가활동분석?.weak ? `줄었거나 못하는 활동: ${여가활동분석?.weak}` : null,
        사회심리_여가활동_제한요구사항_full: 여가활동분석?.weakFull ? `줄었거나 못하는 활동: ${여가활동분석?.weakFull}` : null,
        사회심리_사회활동_강점: 사회활동분석?.strong ? `하고 있거나 즐거운 활동: ${사회활동분석?.strong}` : null,
        사회심리_사회활동_강점_full: 사회활동분석?.strongFull ? `하고 있거나 즐거운 활동: ${사회활동분석?.strongFull}` : null,
        사회심리_사회활동_제한요구사항: 사회활동분석?.weak ? `줄었거나 못하는 활동: ${사회활동분석?.weak}` : null,
        사회심리_사회활동_제한요구사항_full: 사회활동분석?.weakFull ? `줄었거나 못하는 활동: ${사회활동분석?.weakFull}` : null,
        사회심리_정서_강점: 정서분석?.strong ? 정서분석.strong : null,
        사회심리_정서_제한요구사항: 정서분석?.weak ? 정서분석.weak : null,
        건강_건강상태_강점: 건강상태분석?.strong ? `꾸준히 복용하는 것들: ${건강상태분석.strong}` : null,
        건강_건강상태_제한요구사항: 건강상태분석?.weak ? `앓고있는 질환: ${건강상태분석.weak}` : null,
        건강_생활습관_강점: 생활습관분석?.strong ? `${생활습관분석.strong}` : null,
        건강_생활습관_제한요구사항: 생활습관분석?.weak ? `${생활습관분석.weak}` : null,
        건강_신체활동_강점: 신체활동분석?.strong ? `${신체활동분석.strong}` : null,
        건강_신체활동_제한요구사항: 신체활동분석?.weak ? `${신체활동분석.weak}` : null,
        건강_영양_강점: 영양분석?.strong ? `${영양분석.strong}` : null,
        건강_영양_제한요구사항: 영양분석?.weak ? `${영양분석.weak}` : null,
        안전지지_행동_강점: 행동분석?.strong ? 행동분석.strong : null,
        안전지지_행동_제한요구사항: 행동분석?.weak ? 행동분석.weak : null,
        안전지지_환경_강점: 환경분석?.strong ? 환경분석.strong : null,
        안전지지_환경_제한요구사항: 환경분석?.weak ? 환경분석.weak : null,
        안전지지_환경_제한요구사항_full: 환경분석?.weakFull ? 환경분석.weakFull : null,
        안전지지_지원체계_강점: 지원체계분석?.strong ? 지원체계분석.strong : null,
        안전지지_지원체계_제한요구사항: 지원체계분석?.weak ? 지원체계분석.weak : null,
        안전지지_지원체계_강점_full: 지원체계분석?.strongFull ? 지원체계분석.strongFull : null,
        안전지지_지원체계_제한요구사항_full: 지원체계분석?.weakFull ? 지원체계분석.weakFull : null,
        안전지지_돌봄환경_강점: 돌봄환경분석?.strong || null,
        안전지지_돌봄환경_제한요구사항: 돌봄환경분석?.weak || null,
        안전지지_돌봄환경_강점_full: 돌봄환경분석?.strongFull || null,
        안전지지_돌봄환경_제한요구사항_full: 돌봄환경분석?.weakFull || null,
      }
    });
  }



  componentDidMount() {
    const { org_id, uid } = this.state.gradedPerson;
    if (!this.unsubscribe) {
      this.unsubscribe = this.props.getDocsOfMemberAction(org_id, uid);
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  handleOnChange = (e, id) => {
    console.log(`id=${id}, value=${e.target.value}`);
    const { valueState } = this.state;
    valueState[id] = e.target.value;
    this.setState({ valueState });
  }

  handleOnChangeCheckbox = (e, id) => {
    console.log(`id=${id}, value=${e.target.checked}`);
    const { valueState } = this.state;
    valueState[id] = e.target.value;
    this.setState({ valueState });
  }

  onClickInfo = (id, event) => {
    const newAnchorEl = { ...this.state.anchorEl, [id]: event.currentTarget };
    this.setState({ anchorEl: newAnchorEl });
  }

  handleClose = (id) => {
    const newAnchorEl = _.clone(this.state.anchorEl);
    delete newAnchorEl[id];
    this.setState({ anchorEl: newAnchorEl });
  }

  save = () => {
    const { valueState } = this.state;
    const { org_id, uid, name, profile_image_url: photoURL, gender, birthday } = this.state;

    const form = {
      type: FORM_TYPE.CUSTOM
    }
    const reporter = {
      uid: this.props.currentUser.uid,
      org_id,
      photoURL: this.props.currentUser.photoURL,
      displayName: this.props.currentUser.displayName
    };

    this.props.createDocAction(org_id, null, {
      valueState,
      reporter,
      target: this.state.gradedPerson,
      form_type: FORM_TYPE.CUSTOM,
      form: {
        order: 1000,
        sku: "form04",
        version: 1,
        목표: "포괄적평가 요약 및 활동계획 수립",
        서식: "4",
        영역: "전체",
        평가대상: "등급자",
        평가도구: "인지지원등급자 프로파일",
        평가시점: "포괄적평가 완료후",
        평가영역: "전체"
      }
    })
      .catch(e => {
        console.error(e);
        this.props.showAlertAction({
          message: `저장에 실패했습니다.`,
          color: 'danger'
        })
        throw e
      })

    return this.props.history.goBack();
  }


  renderHeader1 = () => {
    const { uid, name, profile_image_url = "", gender, birthday } = this.state;

    return <Row>

      <Col>
        <Row className='mb-5'>
          <Col className='text-center font-weight-bold'><h1>4 인지지원등급자 프로파일</h1></Col>
        </Row>
        <Row className={`text-left`}>
          <Col xs={'auto'}>
            <img
              className='rounded-circle'
              style={{ width: 80, height: 80 }}
              src={profile_image_url.length === 0 ? defaultAvatar : profile_image_url}
              alt="등급자 프로필"
            />
          </Col>
          <Col>
            <Row>
              <Col>
                <div style={{ marginBottom: 10 }}>
                  <span style={{ fontWeight: 'bold', fontSize: '1.5em' }}>
                    {name}
                  </span>
                  <span>
                    {` (${gender === 0 ? "여" : "남"} ${moment().diff(birthday, 'years')}세`})
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                {`작성일: ${this.state?.currentDoc?.created_at ? moment(this.state.currentDoc.created_at.seconds * 1000).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")}`}
              </Col>
            </Row>
            <Row>
              <Col>
                {`작성자: ${this.state?.currentDoc?.reporter?.displayName || this.props.currentUser.displayName}`}
              </Col>
            </Row>
          </Col>
        </Row>

      </Col>
    </Row>
  }

  renderInput = (id, placeholder, rows) => {
    const value = this.state.valueState[id];
    return <Input
      {...(rows && rows > 1 ? { rows } : { plaintext: true })}
      readOnly={this.state.readOnly}
      placeholder={placeholder}
      id={id}
      type={'textarea'}
      value={value || ''}
      className={`p-1 border-bottom`}
      onChange={event => this.handleOnChange(event, id)}
    />
  }

  renderInputSection = ({ id, title, inputGroups }) => {

    return <Card>
      <CardHeader><h4 className='font-weight-bold'>{title}</h4></CardHeader>
      <CardBody>
        <Container>
          <Row>
            <Col>
              <Table>
                <thead className='bg-light'>
                  <tr>
                    {
                      inputGroups.map(({ title }, idx) => {
                        return <th key={idx} className={'border border-dark text-center'}>{title}</th>
                      })
                    }
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {
                      inputGroups.map(({ id, 강점references, 강점 }, idx) => {
                        return (
                          <td key={idx} className={'border border-dark text-center'}>
                            {
                              강점references
                                ? <Row xs={12}>
                                  {강점references.map((reference, idx) => <Col key={idx} xs={12}>{reference}</Col>)}
                                </Row>
                                : null
                            }
                            {this.renderInput(`${id}_강점`, 강점 ? 강점 : "강점", 3)}
                            {
                              this.state.valueState[`${id}_강점_full`]
                                ? <Row>
                                  <Col className='text-right'>
                                    <Icon fontSize="small" color={"secondary"} onClick={(e) => this.onClickInfo(`${id}_강점_full`, e)}>info</Icon>
                                    <Popover
                                      id={`${id}_강점_full`}
                                      open={Boolean(this.state.anchorEl[`${id}_강점_full`])}
                                      anchorEl={this.state.anchorEl[`${id}_강점_full`]}
                                      onClose={() => this.handleClose(`${id}_강점_full`)}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                      }}
                                    >
                                      <div className='p-2'>{this.state.valueState[`${id}_강점_full`].split(',').map((txt, idx) => <li key={idx}>{txt}</li>)}</div>
                                    </Popover>
                                  </Col>
                                </Row>

                                : null
                            }
                          </td>
                        )
                      })
                    }
                  </tr>
                  <tr>
                    {
                      inputGroups.map(({ id, 제한요구사항references, 제한요구사항 }, idx) => {
                        return (
                          <td key={idx} className={'border border-dark text-center'}>
                            {
                              제한요구사항references
                                ? <Row xs={12}>
                                  {제한요구사항references.map(reference => <Col xs={12}>{reference}</Col>)}
                                </Row>
                                : null
                            }
                            {this.renderInput(`${id}_제한요구사항`, 제한요구사항 ? 제한요구사항 : "제한/요구사항", 3)}
                            {
                              this.state.valueState[`${id}_제한요구사항_full`]
                                ? <Row>
                                  <Col className='text-right'>
                                    <Icon fontSize="small" color={"secondary"} onClick={(e) => this.onClickInfo(`${id}_제한요구사항_full`, e)}>info</Icon>
                                    <Popover
                                      id={`${id}_제한요구사항_full`}
                                      open={Boolean(this.state.anchorEl[`${id}_제한요구사항_full`])}
                                      anchorEl={this.state.anchorEl[`${id}_제한요구사항_full`]}
                                      onClose={() => this.handleClose(`${id}_제한요구사항_full`)}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                      }}
                                    >
                                      <div className='p-2'>{this.state.valueState[`${id}_제한요구사항_full`].split(',').map((txt, idx) => <li key={idx}>{txt}</li>)}</div>
                                    </Popover>
                                  </Col>
                                </Row>

                                : null
                            }
                          </td>
                        )
                      })
                    }
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col className='text-center'>
              <img src={require("assets/img/arrow-down.png")} style={{ width: 70, height: 30 }} />
            </Col>
          </Row>
          <Row xs={12}>
            <Col xs={12} className={`p-1 mt-4 border border-primary text-center`}>{this.renderInput(`${id}_활동계획`, "활동계획", 5)}</Col>
          </Row>
        </Container>
      </CardBody>
    </Card>

  }

  renderGoals = () => {
    const { name, goals, valueState } = this.state;

    return <Card>
      <CardHeader>
        <h4 className='font-weight-bold'>{name} 님의 목표 (1개월)</h4>
      </CardHeader>
      <CardBody>
        {
          goals.map((goal, idx) => <Row key={idx}>
            <Col xs={6} justify="flex-end">
              {this.renderInput(`목표${idx + 1}`, `목표${idx + 1}`)}
            </Col>
            <Col xs={6}>
              <div className='form-check-inline'>
                {
                  ["달성", "부분달성", "미달성"]
                    .map((progress, i) => {
                      const key = `목표${idx + 1}_진도_${progress}`;
                      return <FormGroup key={key} check>
                        <Label check>
                          <Input
                            plaintext
                            readOnly={this.state.readOnly}
                            defaultChecked={valueState[`목표${idx + 1}_진도`] === progress}
                            type="radio"
                            name={`목표${idx + 1}_진도`}
                            value={progress}
                            onChange={e => {
                              console.log("this.state = ", this.state);
                              if (e.target.checked) {
                                valueState[`목표${idx + 1}_진도`] = progress;
                                this.setState({ valueState });
                              }
                            }}
                          />
                          <span className="form-check-sign" />
                          {progress}
                        </Label>
                      </FormGroup>

                    })}
              </div>
            </Col>
          </Row>
          )
        }
      </CardBody>
    </Card>

  }

  renderGrade = () => {
    const { MMSE, CDR, GDS } = this.state.valueState;
    return <Card>
      <CardHeader>
        <h4 className='font-weight-bold'>치매/인지지원등급</h4>
      </CardHeader>
      <CardBody>
        <Row>
          <Col>MMSE: </Col>
          <Col>
            <Input
              readOnly
              className={`border-bottom `}
              plaintext
              id="MMSE"
              value={MMSE || ''}
              onChange={(event) => this.handleOnChange(event, "MMSE")} />
          </Col>
          <Col>점</Col>
        </Row>
        <Row>
          <Col>CDR: </Col>
          <Col>
            <Input
              readOnly={this.state.readOnly}
              className={`border-bottom `}
              plaintext
              id="CDR"
              value={CDR || ''}
              onChange={(event) => this.handleOnChange(event, "CDR")}
            />
          </Col>
          <Col>점</Col>
        </Row>
        <Row>
          <Col>GDS: </Col>
          <Col>
            <Input
              readOnly
              className={`border-bottom `}
              plaintext
              id="GDS"
              value={GDS || ''}
              onChange={(event) => this.handleOnChange(event, "GDS")}
            />
          </Col>
          <Col>점</Col>
        </Row>
      </CardBody>
    </Card>
  }

  renderGuide = () => {
    return <Card>
      <CardHeader>
        <h4 className='font-weight-bold'>참고</h4>
      </CardHeader>
      <CardBody className='text-center'>
        <Row>
          <Col className='border bg-light font-weight-bold'>
            영역
          </Col>
        </Row>
        <Row>
          <Col className='border'>
            강점
          </Col>
        </Row>
        <Row>
          <Col className='border'>
            제한 / 요구사항
          </Col>
        </Row>
        <Row>
          <Col className='border'>
            <img src={require("assets/img/arrow-down.png")} style={{ width: 50, height: 30 }} />
          </Col>
        </Row>
        <Row>
          <Col className='border border-primary'>
            활동계획
          </Col>
        </Row>
      </CardBody>
    </Card>
  }

  render신체기능과구조 = () => {
    const { valueState } = this.state;
    return this.renderInputSection({
      id: "건강",
      title: "신체기능과 구조 (건강)",
      inputGroups: [
        {
          id: "건강_건강상태", title: "건강상태", 강점references: [
            <Col xs={12} className='border-0'>
              <div className='text-left'>
                <Checkbox
                  disabled={this.state.readOnly}
                  checked={Boolean(valueState.건강_건강상태_강점 && (valueState.건강_건강상태_강점?.indexOf('치매약') !== -1))}
                />치매약복용
              </div>
            </Col>
          ], 강점: "치매약을 꾸준히 복용하는 것 등", 제한요구사항: "앓고 있는 질환, 관리가 필요한 질환"
        },
        { id: "건강_생활습관", title: "생활습관", 제한요구사항: "관리해야하는 음주, 흡연, 수면습관" },
        { id: "건강_신체활동", title: "신체활동", 강점: "꾸준한 운동 등", 제한요구사항: "운동이 필요한 경우" },
        { id: "건강_영양", title: "영양", 강점: "식사를 챙겨주는 사람 등", 제한요구사항: "식이섭취 어려움 등" },
      ]
    })
  }

  render활동 = () => {
    return this.renderInputSection({
      id: "자립",
      title: "활동(자립)",
      inputGroups: [
        { id: "자립_인지", title: "인지", 강점: "점수가 높은 편인 영역", 제한요구사항: "특히 점수가 낮은 영역" },
        { id: "자립_수단적", title: "수단적", 강점: "가능한 일상생활 영역", 제한요구사항: "도움이 필요한 일상생활 영역" },
        { id: "자립_기본적", title: "기본적", 강점: "가능한 영역", 제한요구사항: "도움이 필요한 영역" }
      ]
    });
  }

  render사회심리 = () => {
    return this.renderInputSection({
      id: "사회심리",
      title: "참여(사회심리)",
      inputGroups: [
        { id: "사회심리_여가활동", title: "여가활동", 강점: "하고 있거나 즐거운 활동", 제한요구사항: "줄었거나 못하는 활동" },
        { id: "사회심리_사회활동", title: "사회활동", 강점: "하고 있거나 즐거운 활동", 제한요구사항: "줄었거나 못하는 활동" },
        { id: "사회심리_정서", title: "정서", 제한요구사항: "관리가 필요한 정도의 우울" }
      ]
    })
  }

  render안전지지 = () => {
    return this.renderInputSection({
      id: "안전지지",
      title: "환경요인(안전,지지)",
      inputGroups: [
        { id: "안전지지_행동", title: "행동", 강점: "정신행동증상 없음", 제한요구사항: "관리가 필요한 정신행동증상" },
        { id: "안전지지_환경", title: "환경", 제한요구사항: "점검표를 통해 확인된 위험한 주거환경" },
        { id: "안전지지_지원체계", title: "지원체계", 강점: "지지 자원이 되는 사항", 제한요구사항: "필요한 서비스나 송영 등" },
        { id: "안전지지_돌봄환경", title: "돌봄환경", 강점: "돌봄 자신감이 높음, 돌봄가족의 지지 자원이 있음 등", 제한요구사항: "치매교육을 받지 않음, 가족부담이 큼 등" }
      ]
    });
  }

  render개별성 = () => {

    // return this.renderInputSection({
    //   id: "개별성",
    //   title: "개별요인(개별성)",
    //   inputGroups: [
    //     { id: "개별성_생활사", title: "생활사", 강점: "종교, 좋았던 기억, 행복했던 순간 등", 제한요구사항: "" },
    //     { id: "개별성_활동수준", title: "활동수준", 강점: "계획수준의 활동", 제한요구사항: "탐색, 감각, 반사수준의 활동" },
    //   ]
    // });

    const {
      개별성_활동수준_활동수준,
      개별성_활동수준_읽기,
      개별성_활동수준_쓰기
    } = this.state.valueState;

    return <Card>
      <CardHeader><h4 className='font-weight-bold'>개별요인(개별성)</h4></CardHeader>
      <CardBody>
        <Container>
          <Row>
            <Col>
              <Table>
                <thead className='bg-light'>
                  <tr>
                    <th className={'border border-dark text-center'} colSpan={2}>생활사</th>
                    <th className={'border border-dark text-center'} colSpan={2}>활동수준</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={'border border-dark text-center'}>
                      {this.renderInput(`개별성_생활사_강점`, '종교, 좋았던 기억, 행복했던 순간 등', 5)}
                    </td>
                    <td className={'border border-dark text-center'} rowSpan={2}>
                      {this.renderInput(`개별성_생활사_하루일과`, '하루 일과', 5)}
                    </td>
                    <td className={'border border-dark text-center'}>
                      {this.renderInput(`개별성_활동수준_강점`, '계획수준의 활동:', 5)}
                    </td>
                    <td className={'border border-dark text-center'} rowSpan={2}>
                      <Col xs={12} className='border-0'>
                        {
                          ['계획수준', '탐색수준', '감각수준', '반사수준'].map((item, idx) => <div className='text-left'>
                            <Checkbox
                              key={idx}
                              readOnly={true}
                              checked={Boolean(개별성_활동수준_활동수준 === item)}
                            />{item}
                          </div>)
                        }
                        <br />
                        <div className='text-left'>
                          <Checkbox
                            readOnly={true}
                            checked={Boolean(개별성_활동수준_읽기 === '가능')}
                          />읽기(가능/불가능)
                    </div>
                        <div className='text-left'>
                          <Checkbox
                            readOnly={true}
                            checked={Boolean(개별성_활동수준_쓰기 === '가능')}
                          />쓰기(가능/불가능)
                    </div>
                      </Col>

                    </td>
                  </tr>
                  <tr>
                    <td className={'border border-dark text-center'}>
                      {this.renderInput(`개별성_생활사_제한요구사항`, '하고 싶은 일 등', 5)}
                    </td>
                    <td className={'border border-dark text-center'}>
                      {this.renderInput(`개별성_활동수준_제한요구사항`, '탐색, 감각, 반사수준활동:', 5)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col className='text-center'>
              <img src={require("assets/img/arrow-down.png")} style={{ width: 70, height: 30 }} />
            </Col>
          </Row>
          <Row xs={12}>
            <Col xs={12} className={`p-1 mt-4 border border-primary text-center`}>{this.renderInput(`개별성_활동계획`, "활동계획", 5)}</Col>
          </Row>
        </Container>
      </CardBody>
    </Card>
  }

  render() {
    const { uid } = this.state;
    const { doc } = this.props;

    const docs = doc[uid]?.map(doc => doc.data());
    if (!this.state.readOnly) {
      this.initData(docs);
    }

    return (
      <Container className='container-fluid'>
        <Row className='mb-4'>
          <Col>
            {this.renderHeader1()}
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col xs={6}>
            {this.renderGoals()}
          </Col>
          <Col xs={3}>
            {this.renderGrade()}
          </Col>
          <Col xs={3}>
            {this.renderGuide()}
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col>
            {this.render신체기능과구조()}
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col>
            {this.render활동()}
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col>
            {this.render사회심리()}
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col>
            {this.render안전지지()}
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col>
            {this.render개별성()}
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col className='text-right'>
            {
              this.state.readOnly
                ? <Button color='primary' onClick={this.props.onClose}>닫기</Button>
                : <Button color='primary' onClick={this.save}>저장</Button>
            }
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  currentOrg: state.org.currentOrg,
  doc: state.doc,
  // currentGroup: state.
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Form04Style),
)(Form04);
